
<div class="dialog-form">
        <div class="table">
            <p-pickList [responsive]="true" dragdrop="true" [source]="ownersSource" [target]="ownersTarget"
                (onMoveToSource)="moveToSource()" (onMoveToTarget)="moveToTarget()" 
                (onMoveAllToSource)="moveToSource()" (onMoveAllToTarget)="moveToTarget()"
                class="full-width content"
                [showSourceControls]="false" [showTargetControls]="false">
                <ng-template let-item pTemplate="item">
                    <div class="quota" (dblclick)="$event.stopPropagation()">
                        {{item.customer.name}}
                        <div class="quota-input" *ngIf="item.hasInput">
                            <input
                                pInputText
                                type="number"
                                min="0"
                                max="100"
                                [(ngModel)]="item.singleOrderQuota"
                                [name]="'slingOrderQuota' + item.customer.id"
                                (blur)="getQuota($event, item); calculateQuota()"
                                (input)="calculateQuota()"
                                [ngClass]="{'invalid-input': invalidQuota}"
                            />
                            %
                        </div>
                    </div>
                </ng-template>
            </p-pickList>
            <div *ngIf="invalidQuota" class="alert alert-danger">
                {{ 'QUOTA-MUSTBE100-MESSAGE' | translate }}
            </div>
        </div>    
    </div>
    